import { render, staticRenderFns } from "./BaixaItemBemPermanenteEstornoForm.vue?vue&type=template&id=b6b8469c&scoped=true"
import script from "./BaixaItemBemPermanenteEstornoForm.vue?vue&type=script&lang=js"
export * from "./BaixaItemBemPermanenteEstornoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b8469c",
  null
  
)

export default component.exports